import { render, staticRenderFns } from "./AddNewDeposit.vue?vue&type=template&id=5bf4fb0a&scoped=true"
import script from "./AddNewDeposit.vue?vue&type=script&lang=ts"
export * from "./AddNewDeposit.vue?vue&type=script&lang=ts"
import style0 from "./AddNewDeposit.vue?vue&type=style&index=0&id=5bf4fb0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf4fb0a",
  null
  
)

export default component.exports